import { ReactNode } from 'react';
import { Text } from 'theme-ui';

export const GVestSport = ({ text }: { text: string }) => {
  return (
    <>
      {text.split(' ').map((word, index): ReactNode => {
        if (/sport/i.test(word) || /apparel/i.test(word)) {
          return (
            <Text key={`sport${index}`} sx={{ fontWeight: 300 }} data-testid="sport-word">
              {word + ' '}
            </Text>
          );
        }
        if (/<br\/>/i.test(word)) {
          return <br key={`br${index}`} />;
        }
        return word + ' ';
      })}
    </>
  );
};
